import angular from "angular";

import { ApiListItem, ApiValidation, Dates, Reports, Translations } from "@salaxy/core";

import { WizardService, WizardStep } from "../../services";
import { WizardController } from "../bases/WizardController";

/**
 * Provides methods for generating pay certificates.
 */
export class PayCertificateController extends WizardController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["$scope", "WizardService", "Reports"];

  /** Worker for the report */
  public worker: ApiListItem = null;

  /** Selected workers */
  public selectedWorkers: ApiListItem[] = [];

  /** Period calculations */
  public periodCalculations: ApiListItem[] = [];

  /** Validation for the report. */
  public validation: ApiValidation = null;

  /** Pay certificate wizard configuration */
  public wizardSteps: WizardStep[] = [
    {
      title: Translations.get("SALAXY.NG1.PayCertificateComponent.wizard.stepSelectWorkerTitle"),
      view: "salaxy-components/report/PayCertificateStep1.html",
    },
    {
      title: Translations.get("SALAXY.NG1.PayCertificateComponent.wizard.stepSelectPeriodCalcsTitle"),
      view: "salaxy-components/report/PayCertificateStep2.html",
    },
    {
      title: Translations.get("SALAXY.NG1.PayCertificateComponent.wizard.stepAdditionalInfoTitle"),
      view: "salaxy-components/report/PayCertificateStep3.html",
    },
  ];

  constructor($scope: angular.IScope, wizardService: WizardService, private reports: Reports) {
    super($scope, wizardService);
  }

  /**
   * Initialization of the controller
   */
  public $onInit() {
    super.$onInit();
    this.wizardService.setSteps(this.wizardSteps);
    this.wizardService.activeStepNumber = 1;
  }

  /** Returns true if goNext is enabled  */
  public get canGoNext(): boolean {
    if (this.steps.length > this.step) {
      if (this.steps[this.step] && !this.steps[this.step].disabled) {
        if (this.step === 1 && this.selectedWorkers.length === 0) {
          return false;
        }
        if (this.step === 2 && this.periodCalculations.length === 0) {
          return false;
        }

        return true;

      }
    }
    return false;
  }

  /**
   * Navigates to the next step if possible
   */
  public goNext() {
    super.goNext();
    if (this.step === 3) {
      this.validate();
    }
  }

  /** Selects the worker and advances the workflow */
  public selectWorker(worker: ApiListItem, isSelected: boolean) {
    if (isSelected) {
      this.worker = worker;
      this.selectedWorkers.splice(0, this.selectedWorkers.length);
      this.selectedWorkers.push(this.worker);
      this.periodCalculations = [];
      this.validation = null;
      this.goNext();
    }
  }

  /** Selects calculations from the period */
  public selectCalculations(items: ApiListItem[], weeks: number) {

    // go x weeks to past
    let periodStart = Dates.add("today",-1 * weeks, "week");
    // set to monday of that week
    periodStart = Dates.startEnd(periodStart, "start-week");

    this.periodCalculations.splice(0, this.periodCalculations.length);
    for (const item of items) {
      if (Dates.asDate(item.salaryDate) >= periodStart) {
        this.periodCalculations.push(item);
      }
    }
  }

  /** Selects calculations from the period */
  public unselectCalculations() {
    this.periodCalculations.splice(0, this.periodCalculations.length);
  }

  /**
   * Returns the url for downloading pdf.
   * @param inline If true will open the pdf. The default is false: download as attachment.
   * @returns URL for downloading the report.
   */
  public getDownloadPdfUrl(inline = false): string {
    if (
      !this.worker ||
      !this.periodCalculations ||
      this.periodCalculations.length === 0) {
      return null;
    }
    return this.reports.getPayCertificatePdfUrl(this.worker.otherId, this.periodCalculations.map( (x) => x.id), inline);
  }

  /**
   * Validates the report server side.
   */
  public validate() {
    this.validation = null;
    if (
      !this.worker ||
      !this.periodCalculations ||
      this.periodCalculations.length === 0) {
      return;
    }
    this.reports.validatePayCertificate(this.worker.otherId, this.periodCalculations.map( (x) => x.id)).then((result: ApiValidation) => {
      this.validation = result;
    });
  }

  /**
   * Start new wizard
   */
  public startNew() {
    this.step = 1;
    this.worker = null;
    this.selectedWorkers.splice(0, this.selectedWorkers.length);
    this.periodCalculations = [];
    this.validation = null;
  }
}
